import {buildField} from '@eitje/form'
import * as React from 'react'
import {TimePicker} from '~/components'
import * as _ from 'lodash'
import {TimePickerFieldInputTrigger} from './components'

const TimePickerFieldInner = buildField(
	fieldProps => {
		const isDisabled = fieldProps.disabled || fieldProps.readOnly

		return (
			<TimePicker
				{...fieldProps}
				disabled={isDisabled}
				onOpenChange={open => {
					// Support open state subscription in form-3
					fieldProps.onOpenChange?.(open)
					// TODO(Jimmy): Remove this support once the shift modal is migrated to the latest form setup
					// Support open state subscription in form-2
					fieldProps.setOpen?.(open)
				}}
				renderTrigger={timePickerCtx => (
					<TimePickerFieldInputTrigger
						value={timePickerCtx.value}
						validateTimeFn={timePickerCtx.validateTimeFn}
						setOpen={timePickerCtx.setOpen}
						setValue={timePickerCtx.setValue}
						lastSelectedValue={timePickerCtx.lastSelectedValue}
						disabled={isDisabled}
						onChange={fieldProps.onChange}
						placeholder={fieldProps.placeholder}
						onKeyDown={fieldProps.onKeyDown}
						onBlur={fieldProps.onBlur}
						title={fieldProps.title}
					/>
				)}
			/>
		)
	},
	{className: 'time-picker-field', icon: true},
)

export const TimePickerField = React.memo(TimePickerFieldInner, _.isEqual)
